import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ff-address-modal',
  templateUrl: './address-modal.component.html',
  styleUrls: ['./address-modal.component.scss']
})
export class AddressModalComponent implements OnInit {

  @Input() address: [string, string?];
  @Input() city: string;
  @Input() state: string;
  @Input() country: string;

  constructor() { }

  ngOnInit(): void { }

  async copyAddress(_:Event): Promise<void> {
    let copy: Promise<any>;
    if(navigator.clipboard) copy = this.clipboardApi(this.address.join(" "));
    else copy = this.execClipboard(this.address.join(" "));

    copy.then(() => {
      //succed
    }, () => {
      // failed
    });
  }

  execClipboard(address: string) {
    return new Promise((resolve, reject) => {
      const dummy = document.createElement("textarea");
      dummy.value = address;
      dummy.style.top = "0";
      dummy.style.left = "0";
      dummy.style.position = "fixed";

      document.appendChild(dummy);
      dummy.focus();
      dummy.select();
      
      try {
        if(document.execCommand("copy")) {
          resolve(true);
        } else {
          reject("Copy failed");
        }
      } catch(err) {
        reject(err);
      } finally {
        document.body.removeChild(dummy);
      }
    });
  }

  clipboardApi(address: string) {
    return navigator.clipboard.writeText(address);
  }
}
